import HttpClient from './HttpClient';
import { OPINION_SERVICE_HOST, OPINIONS_API_PREFIX } from './RestConstants';

export interface UpdateProfileRequest {
  profilePicture: string;
}

export interface UpdateProfileResponse {
  success: boolean;
  message: string;
  data: {
    user: {
      _id: string;
      username: string;
      email: string;
      profilePicture?: string;
    };
  };
}

class ProfileService {
  private static readonly BASE_URL = OPINION_SERVICE_HOST;
  private static readonly PROFILE_PREFIX = `${OPINIONS_API_PREFIX}/auth`;

  static async updateProfile(data: UpdateProfileRequest): Promise<UpdateProfileResponse> {
    const response = await HttpClient.PUT({
      BASE_URL: this.BASE_URL,
      END_POINT: `${this.PROFILE_PREFIX}/profile`,
      data
    });
    return response.data;
  }
}

export default ProfileService;
